import React, { useEffect, useState, useCallback, useRef } from "react";
import { Dropdown, Modal, Button, Tabs, Tab } from "react-bootstrap";
import { Formik, Field, Form as FormikForm, ErrorMessage } from "formik";
import * as Yup from "yup";
import * as XLSX from "xlsx";
import toast from "react-hot-toast";
import Spinner from "../components/Common/Spinner";
import {
  addFile,
  createNewAdmin,
  deleteAdmin,
  getCategory,
  getSubAdmins,
  getUrl,
  updateAdminInfo,
  updateAdminStatus,
  vendorCategory,
  vendorRequest,
} from "../../services/Admin/adminServices";
import Pagination from "../components/Pagination";
import { useFetcher, useNavigate, useLocation } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { exportWaitList, getWaitList } from "../../services/UserServices/UserService";

const Waitlist = () => {
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedAdmin, setSelectedAdmin] = useState(null);

  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

 
const [showExportModal, setShowExportModal] = useState(false);
  const [exportType, setExportType] = useState("excel");
  const location = useLocation();
  const [currentPage, setCurrentPage] = useState(
    location.state?.currentPage ?? 0
  );
  const [itemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [activeTab, setActiveTab] = useState(
    location.state?.activeTab || "User"
  );
  const [type, setType] = useState("");
 const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [confirmState, setConfirmState] = useState({
    show: false,
    action: null,
    id: null,
    status: null,
    message: "",
  });
 const navigate = useNavigate();
  const [uploading, setUploading] = useState(false);
  const [preview, setPreview] = useState("");
  const fileInputRef = useRef(null);
  const [imageLoading, setImageLoading] = useState(false);
  const [submit, setSubmit] = useState(false);
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="12" cy="5" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="19" r="2"></circle>
      </g>
    </svg>
  );

  const fetchAdmins = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getWaitList(
        currentPage,
        itemsPerPage,
        debouncedSearch
      );
      setAdmins(response?.data?.data?.waitList || []);
      setTotalItems(response?.data?.data?.total || 0);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load data");
    } finally {
      setLoading(false);
    }
  }, [
    currentPage,
    itemsPerPage,
    debouncedSearch,

  ]);

  useEffect(() => {
    fetchAdmins();
  }, [fetchAdmins]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearch(search.trim());
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [search]);

  

  useEffect(() => {
    if (currentPage !== undefined) {
      navigate(".", {
        replace: true,
        state: { ...location.state, currentPage, activeTab },
      });
    }
  }, [currentPage, activeTab]);

  const isInitialMount = useRef(true);
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    setCurrentPage(0);
  }, [debouncedSearch, startDate, endDate, type]);

  const activeTabMount = useRef(true);
  useEffect(() => {
    if (activeTabMount.current) {
      activeTabMount.current = false;
      return;
    }
    setSearch("");
    setCurrentPage(0);
    setType("");
  }, [activeTab]);

  const getUrlImage = async (img) => {
    try {
      return await getUrl(img);
    } catch (error) {
      console.error(error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteAdmin(id);
      toast.success("Successfully deleted");
      fetchAdmins();
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to delete user");
      console.error(error);
    }
  };

  const handlestatus = async (id) => {
    try {
      const payload = { userId: id };
      await updateAdminStatus(payload);
      toast.success("Status updated successfully");
      fetchAdmins();
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to update status");
      console.error(error);
    }
  };

  const handleFileUpload = async (e, fieldName, setFieldValue) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      setUploading(true);
      const formData = new FormData();
      formData.append("file", file);
      const res = await addFile(formData);

      if (res) {
        setPreview(URL.createObjectURL(file));
        setFieldValue("image", res?.data?.data?.fileUrl);
      }
    } catch (error) {
      toast.error("File upload failed");
      setPreview("");
    } finally {
      setUploading(false);
    }
  };

  

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedAdmin(null);
    setPreview("");

    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const AdminSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    image: Yup.string().required("image is required"),
  });

  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handleSubmit = async (values, { resetForm }) => {
    try {
      setSubmit(true);
      if (selectedAdmin) {
        const payload = {
          id: selectedAdmin._id,
          name: values.name,
          image: values.image,
        };
        await updateAdminInfo(payload);
        toast.success("Updated successfully");
      } else {
        await createNewAdmin(values);
        toast.success("Added successfully");
        resetForm();
      }
      fetchAdmins();
      setShowModal(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to save admin");
    } finally {
      setSubmit(false);
    }
  };

 

  const isFilterActive = search || startDate || endDate || type;

  const handleRequest = async (status, id) => {
    try {
      const payload = {
        id: id,
        status: status,
      };
      await vendorRequest(payload);
      toast.success(`Request Successfully ${status}ed`);
      fetchAdmins();
    } catch (error) {
      console.error(error);
    }
  };

  const handleClear = () => {
    setSearch("");
    
    setType("");
  };

  // 🌟 Trigger Confirmation Modal
  const triggerConfirm = (action, id, status = null) => {
    let message = "";
    if (action === "delete") {
      message =
        "Are you sure you want to delete this record? This action cannot be undone.";
    } else if (action === "status") {
      message = `Are you sure you want to ${status.toLowerCase()} this account?`;
    } else if (action === "request") {
      message = `Are you sure you want to ${status.toLowerCase()} this vendor's request?`;
    }

    setConfirmState({ show: true, action, id, status, message });
  };

  // 🌟 Execute Action After Confirmation
  const confirmActionHandler = () => {
    const { action, id, status } = confirmState;
    if (action === "delete") {
      handleDelete(id);
    } else if (action === "status") {
      handlestatus(id);
    } else if (action === "request") {
      handleRequest(status, id);
    }
    setConfirmState({
      show: false,
      action: null,
      id: null,
      status: null,
      message: "",
    });
  };


  const handleExport = async (values) => {
    if (!admins || admins.length === 0) {
      toast.error("No listing data available to export");
      return;
    }
    const payload = {
      startDate: values.startDate,
      endDate: values.endDate,
      exportType: values.exportType || exportType || "excel",
    };

    try {
      const res = await exportWaitList(payload.startDate, payload.endDate);
      const data = res?.data?.data?.waitList;

      if (!data || data.length === 0) {
        toast.error("No data found for selected date range");
        return;
      }

      if (payload.exportType === "excel") {
        const excelRows = data.map((admin, index) => {
          const serialNo = index + 1;
          const name = admin.name
            ? `${admin.name.charAt(0).toUpperCase()}${admin.name.slice(1)}`
            : "_";
          const email = admin.email ? admin.email : "_";
          const whatsapp = admin.whatsappNumber
            ? `${admin.countryCode || ""} ${admin.whatsappNumber}`
            : "_";

          let joinedDate = "_";
          if (admin.createdAt) {
            const d = new Date(admin.createdAt).toLocaleDateString("en-CA", {
              day: "2-digit",
              month: "short",
              year: "numeric",
              timeZone: "UTC",
            });
            const t = new Date(admin.createdAt).toLocaleTimeString("en-CA", {
              hour: "2-digit",
              minute: "2-digit",
              timeZone: "UTC",
            });
            joinedDate = `${d} ${t}`;
          }

          const city = admin.city ? admin.city : "_";
          const reason = admin.whatYouWant
            ? admin.whatYouWant.charAt(0).toUpperCase() + admin.whatYouWant.slice(1)
            : "_";

          return {
            "Sr No.": serialNo,
            "Name": name,
            "Email": email,
            "Whatsapp Number": whatsapp,
            "City": city,
            "Joined Date": joinedDate,
            "Reason": reason,
          };
        });

        const worksheet = XLSX.utils.json_to_sheet(excelRows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Waitlist");

        worksheet["!cols"] = [
          { wch: 8 },
          { wch: 22 },
          { wch: 28 },
          { wch: 20 },
          { wch: 18 },
          { wch: 22 },
          { wch: 30 },
        ];

        XLSX.writeFile(
          workbook,
          `WAITLIST-${payload.startDate}-TO-${payload.endDate}.xlsx`
        );

        toast.success("Excel file downloaded successfully!");
      } else {
        const csvHeaders = [
          "Sr No.",
          "Name",
          "Email",
          "Whatsapp Number",
          "City",
          "Joined Date",
          "Reason",
        ];

        const csvRows = data.map((admin, index) => {
          const serialNo = index + 1;
          const name = admin.name
            ? `${admin.name.charAt(0).toUpperCase()}${admin.name.slice(1)}`
            : "_";
          const email = admin.email ? admin.email : "_";
          const whatsapp = admin.whatsappNumber
            ? `${admin.countryCode || ""} ${admin.whatsappNumber}`
            : "_";

          let joinedDate = "_";
          if (admin.createdAt) {
            const d = new Date(admin.createdAt).toLocaleDateString("en-CA", {
              day: "2-digit",
              month: "short",
              year: "numeric",
              timeZone: "UTC",
            });
            const t = new Date(admin.createdAt).toLocaleTimeString("en-CA", {
              hour: "2-digit",
              minute: "2-digit",
              timeZone: "UTC",
            });
            joinedDate = `${d} ${t}`;
          }

          const reason = admin.whatYouWant
            ? admin.whatYouWant.charAt(0).toUpperCase() + admin.whatYouWant.slice(1)
            : "_";

          return [
            serialNo,
            `"${name.replace(/"/g, '""')}"`,
            `"${email.replace(/"/g, '""')}"`,
            `"${whatsapp.replace(/"/g, '""')}"`,
            `"${admin.city ? admin.city : "_"}"`,
            `"${joinedDate.replace(/"/g, '""')}"`,
            `"${reason.replace(/"/g, '""')}"`,
          ];
        });

        const csvContent = [
          csvHeaders.join(","),
          ...csvRows.map((row) => row.join(",")),
        ].join("\r\n");

        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });
        const downloadUrl = URL.createObjectURL(blob);
        const downloadAnchor = document.createElement("a");
        downloadAnchor.setAttribute("href", downloadUrl);
        downloadAnchor.setAttribute(
          "download",
          `WAITLIST-${payload.startDate}-TO-${payload.endDate}.csv`
        );
        downloadAnchor.style.visibility = "hidden";

        document.body.appendChild(downloadAnchor);
        downloadAnchor.click();
        document.body.removeChild(downloadAnchor);

        toast.success("CSV file downloaded successfully!");
      }
      setShowExportModal(false);
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message || "Failed to export data");
    }
  };

  const ExportSchema = Yup.object().shape({
    startDate: Yup.date().required("Start Date is required"),
    endDate: Yup.date()
      .required("End Date is required")
      .min(
        Yup.ref("startDate"),
        "End Date must be greater than or equal to Start Date"
      ),
    exportType: Yup.string().required("Export format is required"),
  });
  const today = new Date().toISOString().split("T")[0];

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h1 style={{ color: "#E5484D" }}>Waitlist</h1>

        <div className="d-flex align-items-center gap-2">
       

          <button
            onClick={() => {
              setExportType("csv");
              setShowExportModal(true);
            }}
            className="btn btn-sm text-white d-flex align-items-center gap-2 shadow-sm px-3 py-2"
            style={{
              backgroundColor: "#E5484D",
              borderRadius: "0.5rem",
              border: "none",
            }}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="7 10 12 15 17 10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
            Export Waitlist
          </button>
        </div>
      </div>




     <div className="pb-2 d-flex flex-wrap justify-content-between gap-2 align-items-center mb-4">
  {/* <div className="flex-grow-1 position-relative">
    <input
      type="text"
      style={{
        borderRadius: "0.5rem",
        borderColor: "#E5484D",
        paddingRight: "40px",
      }}
      className="form-control w-100"
      placeholder="Search by name, email....."
      value={search}
      onChange={(e) => setSearch(e.target.value)}
    />

    {search && (
      <span
        onClick={handleClear}
        style={{
          position: "absolute",
          right: "12px",
          top: "50%",
          transform: "translateY(-50%)",
          cursor: "pointer",
          fontSize: "20px",
          color: "#6c757d",
          lineHeight: 1,
        }}
      >
   ❌
      </span>
    )}
  </div> */}
</div>

  
          {loading ? (
            <Spinner />
          ) : (
            <div className="table-responsive">
              <table className="table table-striped align-middle shadow-sm">
                <thead className="table-light">
                  <tr>
                    <th>Sr No.</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Whatsapp Number</th>
                          <th>City</th>
                    <th>Joined Date</th>
                     <th>Reason</th>
                    {/* <th>Status</th> */}
                    {/* <th>Action</th> */}
                   
                    {/* <th style={{ textAlign: "center" }}>Action</th> */}
                  </tr>
                </thead>
                <tbody>
                  {admins?.length > 0 ? (
                    admins.map((admin, index) => (
                      <tr key={admin._id || index}>
                        <td>{currentPage * itemsPerPage + index + 1}</td>
                        <td>
                          {admin.name
                            ? `${admin.name
                                .charAt(0)
                                .toUpperCase()}${admin.name.slice(1)}`
                            : "_"}
                        </td>
                        <td>{admin.email ? admin.email : "_"}</td>
                        <td>
                          {admin.whatsappNumber
                            ? `${admin.countryCode || ""} ${admin.whatsappNumber}`
                            : "_"}
                        </td>
                         <td>{admin.city ? admin.city : "_"}</td>
                        <td>
                          {new Date(admin.createdAt).toLocaleDateString(
                            "en-CA",
                            {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            },
                          )}
                          {", "}
                          {new Date(admin.createdAt).toLocaleTimeString(
                            "en-CA",
                            {
                              hour: "2-digit",
                              minute: "2-digit",
                            },
                          )}
                        </td>

  <td>
                          {admin.whatYouWant ?
                        admin.whatYouWant.charAt(0).toUpperCase() + admin.whatYouWant.slice(1)
                            : "_"}
                        </td>

                        
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center">
                        No data found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
      

      <div className="card-footer clearfix mt-3">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center text-center text-md-start">
          <div
            className="dataTables_info fw-bold mb-3 mb-md-0"
            style={{ color: "#E5484D" }}
          >Total User : {totalItems}</div>
          <div className="d-flex align-items-center">
            {totalPages > 0 && (
              
              <Pagination
                pageCount={totalPages}
                pageValue={currentPage}
                setPage={setCurrentPage}
              />
    
            )}
          </div>
        </div>
      </div>

    <Modal
      show={showExportModal}
      onHide={() => setShowExportModal(false)}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Export Waitlist Data</Modal.Title>
      </Modal.Header>

      <Formik
        initialValues={{
          startDate: "",
          endDate: "",
          exportType: exportType || "excel",
        }}
        enableReinitialize
        validationSchema={ExportSchema}
        onSubmit={handleExport}
      >
        {({ errors, touched, isSubmitting, values }) => {
          const today = new Date().toISOString().split("T")[0];

          return (
            <FormikForm>
              <Modal.Body>
                <div className="mb-3">
                  <label className="form-label">Export Format</label>
                  <Field
                    as="select"
                    name="exportType"
                    className="form-select"
                  >
                    <option value="excel">Excel (.xlsx)</option>
                    <option value="csv">CSV (.csv)</option>
                  </Field>
                  <ErrorMessage
                    name="exportType"
                    component="div"
                    className="text-danger"
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Start Date</label>
                  <Field
                    type="date"
                    name="startDate"
                    max={today}
                    className={`form-control ${
                      errors.startDate && touched.startDate ? "is-invalid" : ""
                    }`}
                  />
                  <ErrorMessage
                    name="startDate"
                    component="div"
                    className="text-danger"
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">End Date</label>
                  <Field
                    type="date"
                    name="endDate"
                    min={values.startDate || undefined}
                    max={today}
                    className={`form-control ${
                      errors.endDate && touched.endDate ? "is-invalid" : ""
                    }`}
                  />
                  <ErrorMessage
                    name="endDate"
                    component="div"
                    className="text-danger"
                  />
                </div>
              </Modal.Body>

              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => setShowExportModal(false)}
                >
                  Cancel
                </Button>

                <Button
                  type="submit"
                  disabled={isSubmitting}
                  style={{
                    backgroundColor:
                      values.exportType === "excel" ? "#21a366" : "#E5484D",
                    borderColor:
                      values.exportType === "excel" ? "#21a366" : "#E5484D",
                  }}
                >
                  {values.exportType === "excel" ? "Export Excel" : "Export CSV"}
                </Button>
              </Modal.Footer>
            </FormikForm>
          );
        }}
      </Formik>
    </Modal>

   
    </div>
  );
};

export default Waitlist;
